module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "tableSize flipTable"
  }, [_c('tr', [_vm._l((_vm.tableHeader), function(head, n) {
    return [(!(_vm.isExcel && head === '랜딩페이지')) ? _c('th', {
      key: n,
      staticClass: "tableHeader"
    }, [_vm._v("\n\n        " + _vm._s(head) + "\n      ")]) : _vm._e()]
  })], 2), _vm._v(" "), _c('tbody', [_vm._l((_vm.viewData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "header"
    }, [_c('div', [_c('a', {
      staticClass: "name",
      on: {
        "click": function($event) {
          return _vm.clickHandler(data.creative_url, data.size_nm, data)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.setCreativeNm(data)) + "\n          ")])])]), _vm._v(" "), (!_vm.isExcel) ? _c('td', {
      staticClass: "sortCenter"
    }, [(_vm.checkLanding(data.landing_url)) ? _c('a', {
      attrs: {
        "href": data.landing_url,
        "target": "_blank"
      }
    }, [_vm._v("보기")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "sortCenter"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseDataType(data.imp_cnt)) + "\n        ")])]), _vm._v(" "), (_vm.campaignType !== 'CPCV') ? _c('td', {
      staticClass: "sortCenter"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseDataType(data.click_cnt)) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isInterPlay && _vm.isCampaignType(_vm.campaignType)) ? _c('td', {
      staticClass: "sortCenter"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseDataType(data.click_cnt)) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "sortCenter"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(data.ctr.toFixed(2)) + "\n        ")])]), _vm._v(" "), (_vm.isInterPlay && !_vm.isCampaignType(_vm.campaignType)) ? _c('td', {
      staticClass: "sortCenter"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseDataType(data.view_cnt)) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isInterPlay && _vm.campaignType !== 'CPCV') ? _c('td', {
      staticClass: "sortCenter"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n         " + _vm._s(isNaN(data.vtr) ? 0 : data.vtr.toFixed(1)) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isInterPlay && _vm.campaignType === 'HIP') ? _c('td', {
      staticClass: "sortCenter"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseDataType(data.play_cnt)) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isInterPlay && _vm.isCampaignType(_vm.campaignType)) ? _c('td', {
      staticClass: "sortCenter"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseDataType(data[_vm.isCampaignTypeDataKey()])) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isInterPlay) ? _c('td', {
      staticClass: "sortCenter"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseDataType(data.play_sec_avg)) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isInterPlay) ? _c('td', {
      staticClass: "sortCenter"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseData(data.end_rate, 'rate')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isInterPlay) ? _c('td', {
      staticClass: "sortCenter"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseData(data.play_Q1_rate, 'rate')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isInterPlay) ? _c('td', {
      staticClass: "sortCenter"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseData(data.play_Q2_rate, 'rate')) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isInterPlay) ? _c('td', {
      staticClass: "sortCenter"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.parseData(data.play_Q3_rate, 'rate')) + "\n        ")])]) : _vm._e()])
  }), _vm._v(" "), _c('tr', [_vm._m(0), _vm._v(" "), (!_vm.isExcel) ? _c('td') : _vm._e(), _vm._v(" "), _vm._l((_vm.totalKey), function(data, key) {
    return _c('th', {
      key: key,
      staticClass: "sortCenter"
    }, [_c('div', {
      staticClass: "data_wrap"
    }, [_vm._v("\n          " + _vm._s(_vm.campaignType !== 'CPCV' && data === 'vtr' ? 100.0 : _vm.parseData(_vm.totalData[data], data)) + "\n        ")])])
  })], 2)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "sortCenter total"
  }, [_c('b', [_vm._v("합계")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78cdd333","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/creative/CreativeTable.vue
// module id = 864
// module chunks = 1